import { groupBy, sortBy } from 'lodash';
import moment from 'moment';
import { FaChevronRight, FaFolder, FaFolderOpen, FaRegFolder, FaRegFolderOpen } from "react-icons/fa";
import styled from "styled-components";
import Row from "./Row";
import { P, P1 } from "./Typography";

export const AlphaHeader = styled(P)`
    padding: 0.25rem 1rem;
    background: #f4f4f4;
    text-transform: uppercase;
`

export const Document = styled(({ title, subtitle, ...props }) => {
    return (
        <Row {...props}>
            <div style={{ flex: 1 }}>
                <P1>{title}</P1>
                {/* <P>{subtitle}</P> */}
            </div>
            <FaChevronRight />
        </Row>
    )
})`
    padding: 1rem;
    cursor: pointer;
    background: #f4f4f4; //${props => props.$active ? '#d9d9d9' : 'none'};
    border-bottom: 1px solid #b9b9b9;
    
    &:last-of-type {
        border-bottom: 1px solid #000;
    }
    
    &:hover {
        background: #d9d9d9;
    }

    `

export const Folder = styled(({ title, expanded, ...props }) => {
    return (
        <Row {...props}>
            <P1 style={{ flex: 1 }}>{title}</P1>
            {expanded ? <FaRegFolderOpen /> : <FaRegFolder />}
        </Row>
    )
})`
    padding: 1rem;
    cursor: pointer;
    background: ${props => props.$active || props.expanded ? '#e6e6e6' : '#f4f4f4'};
    border-bottom: 1px solid #b9b9b9;

    &:hover {
        background: #d9d9d9;
    }

`

export const DocumentList = (({ documents = [], onClick }) => {
    const byLetter = groupBy(documents, d => d?.name?.toLowerCase().slice(0, 1));
    const letters = sortBy(Object.keys(byLetter));
    return (
        <>
            {
                letters.map((letter, i) => (
                    sortBy(byLetter[letter], "name").map(doc => (
                        <Document key={doc.id} title={doc.name} subtitle={moment(doc.createdAt).format('MMMM D, YYYY')} onClick={() => onClick(doc)} />
                    ))
                ))
            }
        </>
    )
})